
window.addEventListener('load', function () {
    $('.AjaxModal').on('submit', function (e) {
        console.log('Form capturado');
        e.preventDefault();

        var form = this;

        // 1) Pega a site key do <meta> (sem PHP no JS)
        var siteKeyMeta = document.querySelector('meta[name="recaptcha-site-key"]');
        var siteKey = siteKeyMeta ? siteKeyMeta.getAttribute('content') : '';

        if (!siteKey) {
            console.error('reCAPTCHA site key não encontrada no <meta name="recaptcha-site-key">');
            return;
        }
        if (!window.grecaptcha) {
            console.error('grecaptcha não carregado. Verifique o script da API no <head>.');
            return;
        }

        grecaptcha.ready(function () {
            grecaptcha.execute(siteKey, { action: 'submit' }).then(function (token) {
                // 2) Garante que existe e preenche o(s) input(s) com name correto
                var inputs = form.querySelectorAll('input[name="g-recaptcha-response"]');
                if (inputs.length === 0) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'g-recaptcha-response';
                    input.className = 'g-recaptcha-home';
                    form.appendChild(input);
                    inputs = form.querySelectorAll('input[name="g-recaptcha-response"]');
                }
                inputs.forEach(function (inp) { inp.value = token; });

                // (debug opcional) confira o que vai ser enviado:
                // console.log($(form).serialize());

                // 3) Envia via AJAX (igual ao seu)
                $.ajax({
                    url: $(form).attr('action'),
                    method: 'POST',
                    data: $(form).serialize(),
                    success: function (response) {

                        if (response.status === 'success_repre') {
                            new bootstrap.Modal(document.getElementById('SuccessModal')).show();
                            $('#ModalTitleSuccess').text('Sua mensagem foi enviada com Sucesso !');
                            $('#SuccessModal .modal-body').text(response.message);
                            form.reset();
                            return;
                        }

                        if (response.status === 'success_catalogo') {
                            // Criar link de download
                            const link = document.createElement('a');
                            link.href = response.download_url;
                            link.download = response.file_name;
                            link.target = '_blank';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            new bootstrap.Modal(document.getElementById('SuccessModal')).show();
                            $('#ModalTitleSuccess').text('Sucesso!');
                            $('#SuccessModal .modal-body').text('O download do catálogo foi iniciado.');
                            form.reset();
                            return;
                        }

                        if (response.status === 'success_contato') {
                            new bootstrap.Modal(document.getElementById('SuccessModal')).show();
                            $('#ModalTitleSuccess').text('Mensagem enviada com Sucesso!');
                            $('#SuccessModal .modal-body').html(response.message);
                            form.reset();
                            return;
                        }

                        if (response.status === 'error') {
                            new bootstrap.Modal(document.getElementById('ErrorModal')).show();
                            $('#ModalTitleError').text('Sua solicitação não foi processada, contate o administrador do site !');
                            $('#ErrorModal .modal-body').html(errorMessages);
                            form.reset();
                            return;
                        }

                        if (response.status === 'error_bd') {
                            new bootstrap.Modal(document.getElementById('ErrorModal')).show();
                            $('#ModalTitleError').text('Erro ao inserir dados no Banco de dados');
                            $('#ErrorModal .modal-body').html(errorMessages);
                            form.reset();
                            return;
                        }
                        if (response.status === 'insuccess_repre') {
                            new bootstrap.Modal(document.getElementById('ErrorModal')).show();
                            $('#ModalTitleError').text('Erro ao enviar e-mail, contate o administrador do site.');
                            $('#ErrorModal .modal-body').text('Seu cadastro foi salvo, mas o e-mail não pôde ser disparado. Nossa equipe já foi notificada. ❌');
                            return;
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status === 422) {
                            // Erros de validação
                            let errors = xhr.responseJSON.errors;
                            let errorMessages = '';

                            $.each(errors, function (field, messages) {
                                errorMessages += messages.join('<br>') + '<br>';
                            });

                            new bootstrap.Modal(document.getElementById('ErrorModal')).show();
                            $('#ModalTitleError').text('Campos Obrigatórios !');
                            $('#ErrorModal .modal-body').html(errorMessages);
                            
                        } else {
                            // Outro erro de servidor
                            new bootstrap.Modal(document.getElementById('ErrorModal')).show();
                            $('#ModalTitleError').text('Erro!');
                            $('#ErrorModal .modal-body').text('Erro no servidor. Por favor, tente novamente mais tarde. ❌');
                        }
                    }
                })
                .always(function () {
                    // Avisa o Loading
                    document.dispatchEvent(new CustomEvent('sac:finished', { detail: { formId: 'loadingForm' } }));
                });
            });
        });
    });
});
